<template>
  <div class="desc">
    <div
    class="desc__text"
    v-html="cont"
    />
    <div
      class="desc-html"
      style="display: none;"
      v-html="desc"
      ref="descHtml"
    />
  </div>
</template>

<script>

export default {
  name: 'Desct',
  data() {
    return {
      cont: '',
    };
  },
  props: {
    desc: String,
  },

  watch:{
    desc:{
      handler(newVal){
        newVal && this.changeHtml()
      },
    }
  },

  methods: {
    p2div() {
      const { descHtml } = this.$refs;
      const innerHTML = (
        descHtml
          .innerHTML
          .replace(/<p\b/g, '<div')
          .replace(/<\/p>/g, '</div>')
          .replace(/\n/g, '<br />')
      );
      descHtml.innerHTML = innerHTML;
      this.cont = innerHTML;
    },

    parseMath() {
      // eslint-disable-next-line no-undef
      renderMathInElement(
        this.$refs.descHtml,
        {
          delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '$', right: '$', display: false },
          ],
        },
      );
      this.$nextTick(this.p2div);
    },

    changeHtml() {
      this.$nextTick(this.parseMath);
    },
  },

  mounted() {
    this.desc && this.changeHtml();
    
  },
};
</script>

<style lang='less' scoped>
.desc__text {
  ::v-deep img{
    cursor: pointer;
  }
}
</style>
